import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { matchSorter } from 'match-sorter';
import { Autocomplete, Typography } from 'seagull';
import { Plus } from 'seagull/icons';
import { getPMDetails } from '~/integrations/PracticeManagement/pm.utils';
import styles from './PMCompanyDropdown.module.scss';
import { OptionType } from './PMCompanyDropdown.utils';
export default function PMCompanyDropdown(props) {
    const { companies, value, onChange, textFieldProps = {}, loading = false, disabled = false, onInputFocus, onInputBlur, pmType } = props;
    const createNewOption = {
        type: OptionType.CreateNew
    };
    const pmDetails = getPMDetails(pmType);
    const options = useMemo(()=>{
        const options = companies.slice().sort((a, b)=>a.companyName.localeCompare(b.companyName)).map((c)=>({
                type: OptionType.Existing,
                company: c
            }));
        options.unshift(createNewOption);
        return options;
    }, [
        companies
    ]);
    return /*#__PURE__*/ _jsx(Autocomplete, {
        bi: {
            name: 'pm_company'
        },
        helperText: "test",
        collapseHelperText: false,
        testId: "pm-company-dropdown",
        value: value,
        options: options,
        onChange: (_, newOption)=>onChange(newOption),
        disabled: disabled,
        renderOption: (option)=>{
            if ((option === null || option === void 0 ? void 0 : option.type) === OptionType.CreateNew) {
                return /*#__PURE__*/ _jsxs(Typography, {
                    skin: "link",
                    className: styles.newCompanyOption,
                    children: [
                        /*#__PURE__*/ _jsx(Plus, {}),
                        "Push as a new ",
                        pmDetails.company,
                        " to ",
                        pmDetails.name
                    ]
                });
            } else {
                return /*#__PURE__*/ _jsx(Typography, {
                    ellipsis: true,
                    testId: "company-name",
                    children: option.company.companyName
                });
            }
        },
        getOptionLabel: (option)=>{
            switch(option === null || option === void 0 ? void 0 : option.type){
                case OptionType.CreateNew:
                    {
                        return "Push as a new ".concat(pmDetails.company);
                    }
                case OptionType.Existing:
                    {
                        return option.company.companyName;
                    }
            }
        },
        getOptionSelected: (option, value)=>{
            if (!value) return false;
            const isExistingCustomerType = option.type === OptionType.Existing && value.type === OptionType.Existing;
            const existingSelected = isExistingCustomerType && option.company.companyId === value.company.companyId;
            const isNewCustomerType = option.type === OptionType.CreateNew && value.type === OptionType.CreateNew;
            return existingSelected || isNewCustomerType;
        },
        filterOptions: (options, param)=>{
            let { inputValue } = param;
            const filtered = matchSorter(options, inputValue, {
                keys: [
                    (opt)=>opt.type === OptionType.Existing ? [
                            opt.company.companyName
                        ] : []
                ]
            });
            filtered.unshift(createNewOption);
            return filtered;
        },
        noOptionsText: "No ".concat(pmDetails.company, " found"),
        loading: loading,
        textFieldProps: _object_spread({
            placeholder: "Select ".concat(pmDetails.company)
        }, textFieldProps),
        disableTyping: (value === null || value === void 0 ? void 0 : value.type) === OptionType.CreateNew,
        selectOnFocus: true,
        disableClearable: false,
        multiple: false,
        freeSolo: false,
        onFocus: onInputFocus,
        onBlur: onInputBlur
    });
}
